import React from "react";
import cx from "classnames";
import styles from "./Badge.module.scss";

export interface BadgeProps {
  className?: string;
  theme?: "neutral" | "dark" | "success" | "danger";
  onDismiss?: () => void;
}

const Badge: React.FC<BadgeProps> = ({ className, children, theme = "neutral" }) => {
  return (
    <span
      className={cx(styles.badge, className, {
        [styles.neutral]: theme === "neutral",
        [styles.dark]: theme === "dark",
        [styles.success]: theme === "success",
        [styles.danger]: theme === "danger",
      })}
    >
      {children}
    </span>
  );
};

export default Badge;
